var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0391 0C15.3627 0 15.625 0.262333 15.625 0.585938V2.42188H17.4609C17.7845 2.42188 18.0469 2.68421 18.0469 3.00781V19.4141C18.0469 19.7377 17.7845 20 17.4609 20H4.96094C4.63733 20 4.375 19.7377 4.375 19.4141V17.5781H2.53906C2.21546 17.5781 1.95312 17.3158 1.95312 16.9922V5.27344C1.95312 5.11804 2.01486 4.96901 2.12475 4.85912L6.81225 0.171623L6.82266 0.161438C6.93145 0.0579228 7.07602 0 7.22656 0H15.0391ZM15.625 16.9922C15.625 17.3158 15.3627 17.5781 15.0391 17.5781H5.54688V18.8281H16.875V3.59375H15.625V16.9922ZM7.8125 5.27344C7.8125 5.59704 7.55017 5.85938 7.22656 5.85938H3.125V16.4062H14.4531V1.17188H7.8125V5.27344ZM3.95363 4.6875H6.64062V2.0005L3.95363 4.6875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.616babd9fa85bbc1cbfece49786552e7.svg";
export { ForwardRef as ReactComponent };